export function getWidthByRank(rank?: number) {
  switch (rank) {
    case 1:
      return 80;
    case 2:
      return 70;
    case 3:
      return 60;
    case 4:
      return 50;
    default:
      return 40;
  }
}

export function getEmojiImagePath(questionType: string): string {
  switch (questionType) {
    case '매끄러운 진행':
      return 'ico-emoji-process1';
    case '구체적인 안내':
      return 'ico-emoji-process2';
    case '일정한 템포':
      return 'ico-emoji-process3';
    case '정시 시작':
      return 'ico-emoji-process4';
    case '구체적인 질문':
      return 'ico-emoji-question1';
    case '적절한 피드백':
      return 'ico-emoji-question2';
    case '차별적인 질문':
      return 'ico-emoji-question3';
    case '답변 준비 시간 제공':
      return 'ico-emoji-question4';
    case '친절한 태도':
      return 'ico-emoji-attitude1';
    case '부정적인 태도':
      return 'ico-emoji-attitude2';
    case '답변에 도움':
      return 'ico-emoji-attitude3';
    case '면접자 긴장 해소':
      return 'ico-emoji-attitude4';
    case '적절한 분위기':
      return 'ico-emoji-atmosphere1';
    case '쾌적한 환경':
      return 'ico-emoji-atmosphere2';
    case '방해 요소':
      return 'ico-emoji-atmosphere3';
    case '릴렉스된 분위기':
      return 'ico-emoji-atmosphere4';
    default:
      return 'ico-emoji-process1';
  }
}
